import { render, staticRenderFns } from "./DoctorDocumentsPlate.vue?vue&type=template&id=0e1e6850&scoped=true&"
import script from "./DoctorDocumentsPlate.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorDocumentsPlate.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorDocumentsPlate.vue?vue&type=style&index=0&id=0e1e6850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1e6850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1e6850')) {
      api.createRecord('0e1e6850', component.options)
    } else {
      api.reload('0e1e6850', component.options)
    }
    module.hot.accept("./DoctorDocumentsPlate.vue?vue&type=template&id=0e1e6850&scoped=true&", function () {
      api.rerender('0e1e6850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorDocumentsPlate.vue"
export default component.exports